import Head from "next/head";
import React from "react";

import FormBuilder from "@app/components/BiForm/BiFormLayout";
import TabularForm from "@app/components/BiForm/TabularForm/TabularForm";

const firstValue = (value: unknown) => (Array.isArray(value) ? value[0] : value);

const BiForm = ({ parameters }) => {
  // `mode=tabular` → spreadsheet-style multi-learner session feedback (group/generic sessions).
  const isTabular = firstValue(parameters?.mode) === "tabular";

  return (
    <>
      <Head>
        <title>Form</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {isTabular ? <TabularForm parameters={parameters} /> : <FormBuilder parameters={parameters} />}
    </>
  );
};

export default BiForm;
